import { stringify } from '../../../../core/utils/query-string'
import {
  ApiPostResponse,
  Earning,
  EarningDriverLetter,
  EarningRide,
  EarningStats,
  PaginatedData,
  QueryParams,
  WeeklyReportApiResponse,
} from '../../../../types/interfaces'
import { client } from '../../client'

export class EarningsService {
  public async getEarningById(earningId: number) {
    return client.get<Earning>(`/earnings/${earningId}`)
  }

  public async getEarningRides(earningId: number, filters?: QueryParams) {
    return client.get<PaginatedData<EarningRide[]>>(
      `/earnings/${earningId}/rides?${stringify(filters as object)}`
    )
  }

  public async getEarnings(filters?: QueryParams) {
    return client.get<PaginatedData<Earning[]>>(
      `/earnings?${stringify(filters as object)}`
    )
  }

  public async getEarningsLetter() {
    return client.get<EarningDriverLetter>('/earnings/letter')
  }

  public async getEarningsStats() {
    return client.get<EarningStats>('/earnings/statistics')
  }

  public async getEarningWeeklyReport(earningId: number) {
    return client.get<WeeklyReportApiResponse>(
      `/earnings/${earningId}/weekly-report`
    )
  }

  public async requestDriverLetter() {
    return client.post<ApiPostResponse>('/earnings/letter', {})
  }
}
